import React from 'react';
import { motion } from 'framer-motion';

const CookiePolicy: React.FC = () => {
  return (
    <div>
      <section className="pt-32 pb-12 bg-gradient-to-br from-primary to-primary/80 text-white">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Cookie Policy</h1>
            <p className="text-xl text-white/80">
              Cookie e strumenti di misurazione usati su Servizio Bolletta
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-sm"
          >
            <div className="prose prose-lg max-w-none">
              <p className="text-lg leading-relaxed text-gray-700 italic">
                Ultimo aggiornamento: 6 ottobre 2026. Titolare: GT Energie Srl, Via Filippo Argelati 10, 20143 Milano (MI), P.IVA IT02812720809.
              </p>

              <h2 className="text-2xl font-bold text-primary mt-8 mb-4">1. Cosa usiamo</h2>
              <p className="text-lg leading-relaxed text-gray-700">
                Il sito serviziobolletta.it usa cookie tecnici e, solo dopo il tuo consenso, strumenti di misurazione e pubblicità di Google. Il contenitore è Google Tag Manager <strong>GTM-5P4RFF6M</strong>. L’account Google Ads è <strong>GT ENERGIE S.R.L.</strong>, ID <strong>AW-16495185430</strong>. Prima della scelta, Google Consent Mode tiene bloccati archiviazione pubblicitaria, dati utente per annunci, personalizzazione annunci e analytics.
              </p>

              <h2 className="text-2xl font-bold text-primary mt-8 mb-4">2. Necessari</h2>
              <p className="text-lg leading-relaxed text-gray-700 mb-4">
                Non richiedono consenso. Servono a far funzionare il sito e a ricordare la tua scelta.
              </p>
              <ul className="list-disc pl-8 mb-6 space-y-2 text-lg text-gray-700">
                <li><strong>cookieConsent</strong> e <strong>cookieConsentTimestamp</strong> — memoria del browser, 180 giorni. Salvano la preferenza sui cookie.</li>
                <li><strong>DAHSBOTSESS</strong> — cookie di sessione, solo se accedi all’area riservata. Durata massima 12 ore, non leggibile da JavaScript.</li>
              </ul>

              <h2 className="text-2xl font-bold text-primary mt-8 mb-4">3. Misurazione</h2>
              <p className="text-lg leading-relaxed text-gray-700">
                Solo se premi Accetta, oppure attivi “Misurazione” in Personalizza. Se nel contenitore GTM è presente Google Analytics, possono essere scritti cookie come <strong>_ga</strong> e <strong>_ga_*</strong> per capire come viene usato il sito.
              </p>

              <h2 className="text-2xl font-bold text-primary mt-8 mb-4">4. Pubblicità (Google Ads)</h2>
              <p className="text-lg leading-relaxed text-gray-700">
                Solo se premi Accetta, oppure attivi “Pubblicità”. Servono a misurare le campagne dell’account Google Ads GT ENERGIE S.R.L. (AW-16495185430) e, se acconsenti, a personalizzare gli annunci. Possono essere usati cookie come <strong>_gcl_au</strong> e cookie di Google nel dominio doubleclick.net. Con il consenso negato i tag restano in modalità limitata: Google può ricevere un segnale senza cookie pubblicitari, utile solo a stimare le conversioni in forma aggregata.
              </p>

              <h2 className="text-2xl font-bold text-primary mt-8 mb-4">5. Come scegliere</h2>
              <p className="text-lg leading-relaxed text-gray-700">
                Alla prima visita compare una barra con Rifiuta e Accetta, allo stesso livello. Puoi anche personalizzare le categorie. La scelta dura 180 giorni. Per cambiarla usa “Gestisci cookie” nel piè di pagina, oppure cancella i dati del sito dal browser.
              </p>

              <h2 className="text-2xl font-bold text-primary mt-8 mb-4">6. Contatti</h2>
              <p className="text-lg leading-relaxed text-gray-700">
                GT Energie Srl<br />
                Via Filippo Argelati 10, 20143 Milano (MI)<br />
                Email: <a href="mailto:privacy@serviziobolletta.it" className="text-primary hover:underline">privacy@serviziobolletta.it</a>
              </p>
              <p className="text-lg leading-relaxed text-gray-700 mt-4">
                Puoi proporre reclamo al Garante per la protezione dei dati personali.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
